//funcion para verificar si es IOS
export const handleDispositivo = () => {
    const { userAgent } = window.navigator;
    let os = null;

    if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
        os = 'Mac OS';
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
        os = 'iOS';
    } else if (/windows|win32|win64|wow32|wow64/.test(userAgent)) {
        os = 'Windows';
    } else if (/Android/.test(userAgent)) {
        os = 'Android';
    } else if (/Linux/.test(userAgent)) {
        os = 'Linux';
    }

    return os;
};